<template lang="pug">
GenericCard#staffEditor.actionDetail(size='50')
  .d-flex.flex-column.px-4.py-4
    .text-large แก้ไขข้อมูล
    .d-flex.pt-4
      EditableAvatar(
        :src='unsavedUser.imgSrc'
        @change='onNewProfilePictureSelected'
      )
      //- img.rounded-circle(:src='unsavedUser.imgSrc' height='96' width='96')

      .detail.ml-4.pl-3.flex-fill
        input.text-large.w-100(
          placeholder='ชื่อ-นามสกุล'
          v-model='unsavedUser.name'
        )

        .d-flex.mt-3
          div.w-50
            .text-small รหัส
            input.text-medium.w-100.mt-2(
              placeholder='รหัส'
              v-model='unsavedUser.employeeId'
            )
          div.w-50.ml-3(v-show='shouldSpecifyArea')
            .text-small เขต
            CustomInputSelectJson(
              v-model='unsavedUser.areaCode'
              :options=`userAreas`
              :disabled='unsavedUser.userRole === `admin`'
            )

        .mt-4
          .text-small ประเภทผู้ใช้งาน
          CustomInputSelectJson(
            v-model='unsavedUser.userRole'
            :options=`userRoles`
          )

    template(v-if='!changePasswordPanelVisible && errors')
      .mt-4
        template(v-for='e in errors')
          .alert.alert-danger
            .text-small.text-right.red
              | {{ e }}

    .mx-auto
      button.btn.btn-upa-secondary.mt-3(@click='submitUser')
        | บันทึก

  hr.w-100.my-0

  .d-flex.flex-column.px-4.py-4
    .text-large เปลี่ยนรหัสผ่าน

    .d-flex.mt-2
      DataItem.flex-fill( title='ชื่อบัญชีเข้าใช้งาน' :value='unsavedUser.username' )
      DataItem.flex-fill( title='รหัสผ่าน' :value='password' )

    button.btn.btn-secondary.w-33.mt-4.mx-auto(@click='changePasswordBtnClicked')
      | เปลี่ยนรหัส

  div(v-show='changePasswordPanelVisible === true')
    .d-flex.flex-column.px-4.py-4.blue-gradient
      .d-flex.align-items-center
        .text-medium ชื่อบัญชี
        InputWithIconSlot.mb-2.ml-auto(
          v-model='newUsername'
          placeholder='ระบุ' width='100%'
          autocomplete='false'
        )
          i.fa.fa-pen
      //- .d-flex.align-items-center
      //-   .text-medium รหัสผ่านปัจจุบัน
      //-   InputWithIconSlot.mb-2.ml-auto(
      //-     placeholder='', width='100%', type='password'
      //-     ref='currentPwd'
      //-   )
      //-     i.fa.fa-pen
      .d-flex.align-items-center
        .text-medium รหัสผ่านใหม่
        InputWithIconSlot.mb-2.ml-auto(
          v-model='newPassword'
          placeholder='ระบุ..', width='100%', type='password'
          autocomplete='new-password'
          ref='pass'
        )
          i.fa.fa-pen
      .text-small.text-right.red(v-if='newPassword !== null && !newPasswordLongEnough')
        | รหัสผ่านต้องมีความยาวมากกว่า 8 ตัวอักษร

      .d-flex.align-items-center
        .text-medium รหัสผ่านใหม่อีกครั้ง
        InputWithIconSlot.mb-2.ml-auto(
          v-model='newPasswordConfirmation'
          placeholder='ระบุ..', width='100%', type='password'
          autocomplete='new-password'
        )
          i.fa.fa-pen
      .text-small.text-right.red(v-if='newPasswordConfirmation !== null && !confirmedNewPassword')
        | กรุณาใส่รหัสผ่านใหม่ให้ตรงกันทั้ง 2 ช่อง

      //- other errors
      template(v-if='errors')
        .mt-4
          template(v-for='e in errors')
            .alert.alert-danger
              .text-small.text-right.red
                | {{ e }}

      button.btn.btn-upa-secondary.w-25.mt-3.mx-auto(
        @click='submitUser'
        :disabled='!isFormDataValid || isSubmitting'
      )
        template(v-if='isSubmitting')
            LoadingIndicator
        template(v-else)
          | บันทึก

</template>

<script>
// import Velocity from 'velocity-animate';

export default {
  computed: {
    password() {
      return '********';
    },
    confirmedNewPassword() {
      if (this.newPassword === this.newPasswordConfirmation) {
        return this.newPassword;
      }
      return null;
    },
    newPasswordLongEnough() {
      return this.newPassword && this.newPassword.length >= 8;
    },
    isFormDataValid() {
      return this.newPasswordLongEnough
            && this.confirmedNewPassword
            && this.newUsername
            && this.newPassword
            && this.isPersonalInfoComplete;
    },
    isPersonalInfoComplete() {
      return this.unsavedUser.areaCode || !this.shouldSpecifyArea;
    },
    shouldSpecifyArea() {
      return ['admin', 'approver'].includes(this.unsavedUser.userRole) === false;
    },

    areaIfNotAdmin() {
      if (this.shouldSpecifyArea) {
        return this.unsavedUser.areaCode;
      }
      return null;
    },
  },
  props: {
    user: {
      default: {
        name: 'ณัฐพนธ์ เชาวนศิลป',
        code: '08594111',
        areaCode: 'NWE',

        username: '08594111',
      },
    },
  },
  watch: {
    user() {
      this.onUserChanged();
    },
  },
  data: () => ({
    isLoading: false,
    isSubmitting: false,

    userAreas: [
      // load from API..
    ],
    userRoles: [
      { value: '', text: 'เลือกประเภทผู้ใช้งาน', disabled: true },
      { value: 'sales', text: 'เซลล์' },
      { value: 'cs', text: 'CS' },
      { value: 'approver', text: 'Approver' },
      { value: 'admin', text: 'Admin' },
    ],
    unsavedUser: {
      areaCode: '',
    },

    changePasswordPanelVisible: false,

    newUsername: '',
    // oldPassword: '',
    newPassword: null,
    newPasswordConfirmation: null,

    newProfilePicture: undefined,

    errors: [],
  }),
  async mounted() {
    // Hacky way to clone an object
    this.onUserChanged();

    this.loadUserAreas();
  },
  methods: {
    async loadUserAreas() {
      this.isLoading = true;

      try {
        const res = await this.$api.admin.permissions.getUserAreas();
        this.userAreas = res.data;
      } catch (e) {
        console.log(JSON.stringify(e));
      }

      this.isLoading = false;
    },
    // async loadUserInfo() {
    //   this.isLoading = true;

    //   const res = await this.$api.user.current();
    //   if (res.status === 200) {
    //     this.user = res.data.data;
    //   }

    //   this.isLoading = false;
    // },
    onUserChanged() {
      this.unsavedUser = JSON.parse(JSON.stringify(this.user));
      this.newUsername = this.unsavedUser.username;
      this.newPassword = null;
      this.newPasswordConfirmation = null;

      this.errors = [];
    },
    changePasswordBtnClicked() {
      this.changePasswordPanelVisible = !this.changePasswordPanelVisible;

      if (this.changePasswordPanelVisible === true) {
        setTimeout(() => {
          // put the first password input box in focus
          this.$refs.currentPwd.$el.children[0].focus();
        }, 100);
      }
    },

    async submitUser() {
      this.isSubmitting = true;

      const formData = new FormData();
      formData.set('username', this.newUsername);
      formData.set('password', this.newPassword);
      formData.set('password_confirmation', this.newPasswordConfirmation);
      formData.set('employee_id', this.unsavedUser.employeeId);
      formData.set('name', this.unsavedUser.name);
      formData.set('area', this.areaIfNotAdmin);
      formData.set('active', 1);
      if (this.newProfilePicture) {
        formData.append('avatar', this.newProfilePicture);
      }
      formData.set('role', this.unsavedUser.userRole);

      // console.log(formData);

      try {
        // console.log(processedUser);
        // const res = await this.$api.admin.permissions.updateUser(this.user.id, processedUser);
        await this.$api.admin.permissions.updateUserWithPic(this.user.id, formData);
        // console.log(res);
        this.errors = [];
        this.$emit('submit');
      } catch (e) {
        // alert(`เกิดข้อผิดพลาด \n${e.message}`);
        console.log(JSON.stringify(e));
        if (e.response && e.response.data && e.response.data.errors) {
          // alert(JSON.stringify(e.response.data.errors));
          const ERR = e.response.data.errors;
          this.errors = Object.keys(e.response.data.errors).map(key => ERR[key]);
        } else if (e.error) {
          this.errors = [`เกิดข้อผิดพลาด.. ${JSON.stringify(e.error)}`];
        } else {
          if (e.message === 'Request failed with status code 401') {
            e.message = 'รหัสผ่านเดิมไม่ถูกต้อง';
          } else if (e.message === 'Request failed with status code 403') {
            e.message = 'คุณไม่มีสิทธิในการแก้ไขข้อมูลผู้ใช้ กรุณาติดต่อแอดมิน';
          }
          this.errors = [e.message];
        }
      }

      this.isLoading = false;
    },

    // SET PROFILE PICTURE
    onNewProfilePictureSelected(e) {
      console.log(e);
      this.newProfilePicture = e;
    },
  },
};
</script>

<style lang="scss">
// .edit-personal-info-panel {}
</style>
